import { render, staticRenderFns } from "./editdatas.vue?vue&type=template&id=2b0c78e6&scoped=true"
import script from "./editdatas.vue?vue&type=script&lang=js"
export * from "./editdatas.vue?vue&type=script&lang=js"
import style0 from "./editdatas.vue?vue&type=style&index=0&id=2b0c78e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0c78e6",
  null
  
)

export default component.exports